import gql from 'graphql-tag'
import client from '@stores/apollo'
import { sortBy } from 'lodash'
import { IPortfolioRegion } from '@api'
import { BuildingDetailsFragment } from '@api/fragments'

interface IPayload {
  data: {
    viewer: {
      company: {
        portfolioRegions: IPortfolioRegion[]
        primaryAssignmentPlan: {
          id: string
        }
      }
    }
  }
}
export default async function regions({
  showInactiveBuildings,
}: {
  showInactiveBuildings: boolean
}): Promise<IPayload> {
  const variables = {
    showInactiveBuildings,
  }
  return client.gql
    .query({ query: portfolioRegionsQuery, variables })
    .then((response: IPayload) => {
      const regions = response.data.viewer.company.portfolioRegions
      for (const region of regions || []) {
        if (!region.cities) region.cities = []
        for (const city of region.cities) {
          if (!city.buildings) city.buildings = []
          for (const building of city.buildings) {
            building.floors = sortBy(building.floors || [], 'story')
          }
        }
      }
      return response
    })
}

export const portfolioRegionsQuery = gql`
  query PortfolioRegions($showInactiveBuildings: Boolean) {
    viewer {
      company {
        portfolioRegions(includeOldBuildings: $showInactiveBuildings) {
          id
          name
          cities {
            id
            name
            buildings {
              ...BuildingDetailsFragment
            }
          }
        }
        primaryAssignmentPlan {
          id
        }
      }
    }
  }
  ${BuildingDetailsFragment}
`
